import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/Logo_Horizontal_Full.png';
import PublicFooter from '../../components/landing/PublicFooter';
import { usePageMeta } from '../../hooks/usePageMeta';
import { LEGAL_DRAFT, LEGAL_UPDATED, legalDocuments, type LegalDocumentKey } from './legalDocuments';
import '../../styles/LandingPage.scss';

const otherDocuments: { key: LegalDocumentKey; label: string }[] = [
    { key: 'privacy', label: 'Privacy' },
    { key: 'cookie', label: 'Cookie' },
    { key: 'termini', label: 'Termini di servizio' },
];

export default function LegalPage({ document: key }: { document: LegalDocumentKey }) {
    const doc = legalDocuments[key];
    usePageMeta({ title: `${doc.title} — Semplora`, description: doc.description, path: `/${key}` });

    return <div className="sp-public">
        <header className="sp-nav">
            <Link to="/" className="sp-nav__brand" aria-label="Semplora, homepage">
                <img src={logo} alt="Semplora — Work made simple" width="174" height="58" />
            </Link>
            <Link className="sp-text-link" to="/">Torna alla homepage</Link>
        </header>
        <main id="contenuto" className="sp-legal sp-section">
            <nav className="sp-legal__switch" aria-label="Documenti legali">
                {otherDocuments.map(item => <Link key={item.key} to={`/${item.key}`} aria-current={item.key === key ? 'page' : undefined}>{item.label}</Link>)}
            </nav>
            <h1>{doc.title}</h1>
            <p className="sp-legal__updated">Ultimo aggiornamento: {LEGAL_UPDATED}</p>
            {LEGAL_DRAFT && <p className="sp-legal__draft" role="note">Bozza in revisione: questo testo non è ancora stato validato e può cambiare.</p>}
            <p className="sp-legal__intro">{doc.intro}</p>
            {doc.sections.map(section => <section key={section.heading}>
                <h2>{section.heading}</h2>
                {section.blocks.map((block, index) => typeof block === 'string'
                    ? <p key={index}>{block}</p>
                    : <ul key={index}>{block.list.map(item => <li key={item}>{item}</li>)}</ul>)}
            </section>)}
        </main>
        <PublicFooter />
    </div>;
}
